import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import ChoiceDriverMarker from '../../../components/ChoiceDriverMarker/ChoiceDriverMarker';
import { isChoiceDriver } from '../model';

const useStyles = makeStyles(({ typography }) => ({
  optionLabel: {
    marginRight: typography.pxToRem(10),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  rightSpace: {
    marginRight: typography.pxToRem(10),
  },
}));

const DriverListOption = ({ option }) => {
  const styles = useStyles();
  return isChoiceDriver(option) ? (
    <span className={styles.optionLabel}>
      <span className={styles.rightSpace}>{option.label}</span>
      <ChoiceDriverMarker />
    </span>
  ) : (
    option.label
  );
};

export default memo(DriverListOption);
